import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
}

export function formatDateLong(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('it-IT', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(date);
}

export function getStatusColor(stato) {
  switch (stato) {
    case 'bozza':
      return 'bg-slate-100 text-slate-600 border-slate-200';
    case 'inviato':
      return 'bg-amber-50 text-amber-700 border-amber-100';
    case 'accettato':
      return 'bg-emerald-50 text-emerald-700 border-emerald-100';
    case 'rifiutato':
      return 'bg-red-50 text-red-700 border-red-100';
    default:
      return 'bg-slate-100 text-slate-600 border-slate-200';
  }
}

export function getStatusLabel(stato) {
  switch (stato) {
    case 'bozza':
      return 'Bozza';
    case 'inviato':
      return 'Inviato';
    case 'accettato':
      return 'Accettato';
    case 'rifiutato':
      return 'Rifiutato';
    default:
      return stato;
  }
}
